<template>
  <AppLayout>
    <div data-component="Export/Layout">
      <div class="page-content">
        <router-view />
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '../../components/Layout/AppLayout.vue'

export default {
  name: 'ExportLayout',
  components: {
    AppLayout
  }
}
</script>

<style scoped lang="scss">
[data-component="Export/Layout"] {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.page-content {
  flex: 1;
  overflow-y: auto;
}
</style>
